import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';

const css = ".ispui-select-add{--ispui-button__fourth_text_regular:var(--isp-text-interactive);--ispui-button__fourth_text_hover:var(--isp-text-interactive__hover);--ispui-button__fourth_text_active:var(--isp-text-interactive__active);--ispui-button__padding-right:0;--ispui-button__padding-left:0;display:var(--ispui-select-add__display, inline-block)}";

const Add = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.addClick = createEvent(this, "addClick", 7);
    /** text for button */
    this.text = 'Добавить';
    /** appearance */
    this.theme = 'default';
  }
  render() {
    const PlusIcon = () => (h("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "-4 -4 29 29", height: "16", width: "16", preserveAspectRatio: "xMidYMid meet", focusable: "false" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 1a1 1 0 10-2 0v8H1a1 1 0 100 2h8v8a1 1 0 102 0v-8h8a1 1 0 100-2h-8V1z", fill: "currentColor" })));
    const layouts = {
      default: (h("button", { class: "ispui-select-add__button ispui-button ispui-button_theme_secondary ispui-button_size_small", onClick: () => this.addClick.emit() }, h(PlusIcon, null), this.text)),
      vmdci: (h("button", { class: "ispui-select-add__button ispui-button ispui-button_theme_inline-blue ispui-button_size_small", onClick: () => this.addClick.emit() }, h(PlusIcon, null), this.text)),
    };
    return h(Host, { class: "ispui-select-add" }, layouts[this.theme]);
  }
  static get style() { return css; }
}, [0, "ispui-select-add", {
    "text": [1],
    "theme": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["ispui-select-add"];
  components.forEach(tagName => { switch (tagName) {
    case "ispui-select-add":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Add);
      }
      break;
  } });
}

const IspuiSelectAdd = Add;
const defineCustomElement = defineCustomElement$1;

export { IspuiSelectAdd, defineCustomElement };
